import { render, staticRenderFns } from "./HomeSwiper.vue?vue&type=template&id=5e4e3cee&scoped=true&"
import script from "./HomeSwiper.vue?vue&type=script&lang=js&"
export * from "./HomeSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e3cee",
  null
  
)

export default component.exports